import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IBonusCreateManuallyPayload } from '@modules/players-bonuses/submodules/components/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  PLAYER_BONUS_API_URL,
  PLAYER_BONUS_EDIT_PERMISSIONS,
  PLAYER_BONUS_EDIT_QUERY_KEY,
} from '@modules/players-bonuses/submodules/edit/constants';
import { useToastStore } from '@modules/toast/store';

export default function usePlayerBonusEditMutation(id: Ref<string>): IContextMutationResult<void, Error, IBonusCreateManuallyPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IBonusCreateManuallyPayload>({
    mutationKey: [PLAYER_BONUS_EDIT_QUERY_KEY],
    mutationFn: (data) => fetchPut<void>(
      PLAYER_BONUS_API_URL(String(id.value)),
      { bonus: { ...data } },
      { permission: PLAYER_BONUS_EDIT_PERMISSIONS.PLAYER_BONUS_EDIT },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
